import {
  type FC, useCallback,
} from 'react';
import { useUserDataSelector } from '~/store/userData/userData.selectors';
import { useQuery } from '../../_shared/utils/hooks/useQuery';
import { useNavigateAfterLogin } from '../loginPage/useNavigateAfterLogin';
import { useVerifyEmail } from './useVerifyEmail';
import { VerifyEmailPageComponent } from './verifyEmailPage.component';

export const VerifyEmailPageContainer: FC = () => {
  const { isLoading, isEmailSending, isVerified, errorMessage, getEmailVerification, resendEmailVerification } = useVerifyEmail();
  const isUserDataLoading = useUserDataSelector().isLoading;
  const query = useQuery();
  const expires = query.get('expires');
  const hash = query.get('hash');
  const id = query.get('id');
  const userEmail = query.get('email');
  const signature = query.get('signature');

  // The verification signs the user in, take them to the app as soon as their data is loaded
  useNavigateAfterLogin(isVerified);

  const startVerification = useCallback(() => {
    if (expires && hash && id && userEmail && signature) {
      getEmailVerification({ expires, hash, id, userEmail, signature });
    }
  }, [expires, hash, id, userEmail, signature, getEmailVerification]);

  const onResend = useCallback((successCallback: () => void, failureCallback: () => void) => {
    if (userEmail) {
      resendEmailVerification(userEmail, successCallback, failureCallback);
    }
  }, [resendEmailVerification, userEmail]);

  return (
    <VerifyEmailPageComponent
      startVerification={startVerification}
      onResend={onResend}
      isLoading={isLoading}
      isEmailSending={isEmailSending}
      isSigningIn={isVerified && isUserDataLoading}
      isVerified={isVerified}
      errorMessage={errorMessage}
    />
  );
};
